<template>
  <div>
    <div>
      <ag-grid-vue
        :style="`width: 100%; height: ${gridHeight}px`"
        :class="gridClass + ' animated fadeIn'"
        :gridOptions="gridOptions"
        :headerHeight="headerHeight"
        :frameworkComponents="gridOptions.frameworkComponents"
        @gridReady="gridIsReady"
        @cellDoubleClicked="onCellDoubleClicked">
      </ag-grid-vue>
    </div>
  </div>

</template>

<script>
  // *****************************************************************************************************************
  //                                                  IMPORTS
  // *****************************************************************************************************************
  // import {sales} from '../../../services/api/ExpertoRetail'
  import {AgGridVue} from 'ag-grid-vue'
  import {GeneralUtils} from '@/mixins/index'

  export default {
    name: '',
    // *****************************************************************************************************************
    //                                                 MIXINS
    // *****************************************************************************************************************
    mixins: [GeneralUtils],
    // *****************************************************************************************************************
    //                                                  PROPS
    // *****************************************************************************************************************
    props: {
      gridClass: {
        type: String,
        default: 'ag-theme-balham'
      },
      gridHeight: {
        type: Number,
        default: 585

      }
    },
    // *****************************************************************************************************************
    //                                                  COMPONENTS
    // *****************************************************************************************************************
    components: {
      'ag-grid-vue': AgGridVue
    },
    data () {
      return {
        loading: false,
        selected: this.selectedRetail,
        retailList: [],
        rowData: {},
        updateStoreView: false,
        loadList: [],
        colDefs: [],
        headerHeight: 130,
        gridOptions: {
          singleClickEdit: true,
          paginationPageSize: 30,
          rowData: [],
          columnDefs: [],
          pagination: true,
          enableColResize: true,
          rowSelection: 'mutiple',
          stopEditingWhenGridLosesFocus: true
        },
        cellCondition: null
      }
    },
    // *****************************************************************************************************************
    //                                                HOOKS
    // *****************************************************************************************************************
    created () {
      this.cellCondition = this.vuexCellCondition
      this.$eventHub.$on('grid-metric-wide-one-metric-fetch-data', this.setGrid)
      this.$eventHub.$on('grid-metric-wide-one-metric-set-to-no-rows', this.setGridToNoRows)
    },
    beforeDestroy () {
      this.$eventHub.$off('grid-metric-wide-one-metric-fetch-data')
      this.$eventHub.$off('grid-metric-wide-one-metric-set-to-no-rows')
    },
    watch: {
      vuexGridData () {
        this.setGrid()
      },
      vuexCellCondition (val) {
        this.setGrid()
      }
    },
    computed: {
      vuexAvailableHeight () {
        return this.$store.state.appAvailableHeight - 40
      },
      vuexCellCondition () {
        return this.$store.state.gridMetricSystemWideOneMetric.cellCondition
      },
      vuexSelectedRetailBusinessParameters () {
        return this.$store.state.generalKeyKpiAnalysis.selectedRetailBusinessParameters
      },
      vuexGridData () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.generalKeyKpiAnalysis.gridData)
      }
    },
    // *****************************************************************************************************************
    //                                                METHODS
    // *****************************************************************************************************************
    methods: {
      autoSizeAll () {
        let allColumnIds = []
        this.gridOptions.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId)
        })
        this.gridOptions.columnApi.autoSizeColumns(allColumnIds)
      },
      cellClassDecider (params) {
        let x = parseFloat(params.value)
        return this.$store.state.gridMetricSystemWideOneMetric.cellCondition(x, this.vuexSelectedRetailBusinessParameters)
      },
      onCellDoubleClicked (params) {
        let cellClicked = {
          'column': params.colDef,
          'row': params.node.data
        }
        this.commitCellClicked(cellClicked)
        // this.goTo()
      },
      buildColumnColorCondition (columns) {
        let colDefs = []
        columns.forEach((i) => {
          i.cellStyle = i.isColumn ? this.cellClassDecider : null
          i.width = i.isColumn ? 38 : 220
          i.pinned = i.isColumn ? null : 'left'
          colDefs.push(i)
        })
        return colDefs
      },
      gridIsReady (params) {
        this.$eventHub.$emit('grid-metric-wide-one-metric-is-ready')
      },
      onBtnExportDataAsCsv () {
        this.gridOptions.api.exportDataAsCsv()
      },
      setGrid () {
        let data = this.vuexGridData
        if (data !== []) {
          this.gridOptions.api.showLoadingOverlay()
          this.gridOptions.api.setRowData(data['data'])
          this.gridOptions.columnDefs = this.buildColumnColorCondition(data['column_definition'])
          this.gridOptions.api.setColumnDefs(this.gridOptions.columnDefs)
          this.gridOptions.api.hideOverlay()
        }
      },
      setGridToNoRows () {
        this.rowData = []
        this.setGrid()
      },
      // ********************************************** VUEX COMMITS ***************************************************
      commitCellClicked (cellClicked) {
        this.$store.commit('commit_gridMetricSystemWideOneMetric_cellClicked', cellClicked)
      }
      // ********************************************** REQUESTS *******************************************************
    }
  }
</script>


<style scoped>
  >>> .ag-header-cell-text {
    /*Force the width corresponding at how much width
    we need once the text is layed out vertically*/
    writing-mode: vertical-rl;
    text-orientation: mixed;
    /*align-self: auto;*/
    transform: rotate(-180deg);

  }

  >>> .ag-header-cell {
    padding: 0;
  }

</style>




// WEBPACK FOOTER //
// src/expertoRetail/components/GridSystems/GridMetricSystemWideOneMetric.vue